// Helper hook để thay thế useAuthHeader từ react-auth-kit
import authService from '../services/authService';

const useAuthHeader = () => {
    return authService.getAccessToken();
};

export default useAuthHeader;
